import { h } from 'preact';

const ContactLink = ({ children, subject, body, ...rest }) => {
	const link = new URL('mailto:cmssupport@powster.com');
	if (subject) link.searchParams.set('subject', subject);
	if (body) link.searchParams.set('body', body);

	return <a href={link.href} target="_blank" {...rest}>{children}</a>;
};

export default ContactLink;